import { Component } from '@angular/core';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
import { SharedService } from './shared/shared.service';

@Component({
  template: ``,
  styles: []
})
export class EnvironmentComponent {
  constructor(
    private router: Router,
    private sharedService : SharedService ){}
  
  ngOnInit(){
    this.sharedService.authenticateUser('','').subscribe((response) => {
      if(this.sharedService.userRole==='unAuthorized'){
        this.navigateToLogin();
      }else{
        this.router.navigate(['/dashboard'],{queryParams: {}}); 
      }
    },
    error => {
      this.navigateToLogin();
    });
  }
  navigateToLogin(){
    this.router.navigate(['/externalRedirect', { externalUrl: environment.taPortal }]);
  }
}



// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/environment.component.ts